import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from '@lib/components/landing-page/landing-page.component';
import { UnauthorizedComponent } from '@lib/components/unauthorized/unauthorized.component';
import { DeclareFicheConseilComponent } from 'src/app/components/declare-fiche-conseil/declare-fiche-conseil.component';
import { MyFichesComponent } from 'src/app/components/my-fiches/my-fiches.component';
import { InitGuard, authGuard } from 'src/app/guards/auth.guard';

const routes: Routes = [
  {
    path: 'fiches',
    title: 'Mes fiches conseil',
    component: MyFichesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fiches/:ficheId',
    title: 'Mes fiches conseil',
    component: MyFichesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'acte/:ficheId',
    title: (route: ActivatedRouteSnapshot) => 'Fiche Conseil ' + (route.params['ficheId'] ?? ''),
    component: DeclareFicheConseilComponent, //paramétrer en fonction de l'acte de gestion
    canActivate: [authGuard],
  },
  {
    path: 'fiche/:ficheId',
    component: DeclareFicheConseilComponent,
    title: (route: ActivatedRouteSnapshot) => 'Fiche Conseil ' + (route.params['ficheId'] ?? ''),
    canActivate: [authGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'init', component: LandingPageComponent, canActivate: [InitGuard] },
  { path: '**', redirectTo: 'fiches' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
